import { object, string, date, boolean, array } from 'yup';
import { COMPANY_TYPES, COUNTRIES, SUBSCRIPTION_STATUSES } from 'resources/company/company.constants';
import { EXTERNAL_SOURCES } from 'resources/user/user.constants';

const companySchema = object({
  id: string(),
  logo_url: string().nullable(),
  bgc_color: string().nullable(),
  name: string(),
  zip: string(),
  // stripe fields -->
  customer_id: string().nullable(),
  subscription_status: string().oneOf(Object.values(SUBSCRIPTION_STATUSES)).nullable(),
  subscribed_on: date().nullable(),
  // stripe fields <--
  type: string().oneOf(Object.values(COMPANY_TYPES)).nullable(),
  env: string().oneOf(['development', 'staging', 'production']).required(),
  integrations: array().of(string().oneOf(Object.values(EXTERNAL_SOURCES))).nullable(),
  skip_agent_invitation: boolean().default(false),
  country: string().oneOf(Object.values(COUNTRIES)).nullable(),
  due_date_calculation: object({
    exclude_weekends: boolean().default(false),
    exclude_federal_holidays: boolean().default(false),
  }),
  attribution: string().nullable(),

  created_on: date().required(),
  updated_on: date().required(),
  trial_expires_on: date().nullable(),
});

export default companySchema;
